const endpoints = {
    searchLihes: 'https://api.travelski.com/se/search/lihe-name'
}

export default endpoints
